import WorkflowPublish from '@apps/truevail/admin/components/workflow_publish'
import PublishingToken from '@apps/truevail/admin/tokens/publishing'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Emails)',
  collection: {
    endpoint: `/api/admin/truevail/admin/workflows/${props.workflow.id}/publishings`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Advisor)', key: 'advisor.organization', sort: 'advisor', format: (publishing) => (
        <PublishingToken publishing={ publishing } />
      ) },
      { label: 't(Published)', key: 'created_at', collapsing: true, format: 'datetime' }
    ],
    defaultSort: { key: 'created_at', order: 'sc' },
    empty: {
      svg: 'workflow',
      title: 't(No Publishings)',
      text: 't(There are no publishings for this workflow)',
      buttons: [
        { 
          label: 't(Publish Advisor Workflow)',
          modal: <WorkflowPublish workflow_id={ props.workflow.id } entity="admin" />
        }
      ]
    },
    entity: 'publishing',
    onClick: (record) => {
      const { provider, host } = context
      host.window.open(`${provider.admin_host}/${record.advisor.team.subdomain}/automation/workflows/${record.advisor_workflow.id}`)
    }
  },
  task: {
    svg: 'plus',
    tooltip: 't(Publish Advisor Workflow)',
    modal: <WorkflowPublish workflow_id={ props.workflow.id } entity="admin" />
  }
})

export default Panel(null, mapPropsToPanel)
